import {Injectable} from '@angular/core';
import {BimModelService} from '@cas-hub/acabim-common-client';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BimModelAdministrationService extends BimModelService {

    public deleteBimModel(modelId: string): Observable<any> {
        return this.client.delete(this.url(modelId), {
            headers: this.defaultHeaders,
            responseType: 'json'
        });
    }
}
